import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, message } from 'antd'
import 'antd/dist/antd.css';
import '../index.css'
import CustomizedForm from '../CustomForm'
import { OPS_DATA_URL } from '../../config';
import { getNowTimestamp } from '../../utils/CommonUtil';
import { getAuthEmailFromToken, authenticateToken } from '../../utils/auth';

class MaintenceDataModalPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      fields: {},
      loading: false
    }
  }

  static propTypes = {
    visible: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    title: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  handleFormChange = changedFields => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  };

  loadingChangeState(status) {
    this.setState({
      loading: status
    })
  }

  normalizeWindowValues = (values) => {
    const start = getNowTimestamp(values['start_time']);
    let end = getNowTimestamp(values['end_time']);
    if (end <= start) {
      end = start + (60 * 60 * 1000);
    }
    return { start, end };
  }

  parseErrorMessage = async (res) => {
    try {
      const data = await res.json();
      if (data && data.error) return data.error;
      if (data && data.message) return data.message;
    } catch (e) {
      // no-op
    }
    return `Request failed with status ${res.status}`;
  }

  submitEditClick = async (e) => {
    let authToken = authenticateToken();
    e.preventDefault()
    const { form } = this.formRef.props;
    form.validateFields(async (err, values) => {
      if (err) {
        return;
      } else {
        this.loadingChangeState(true)
        const { start, end } = this.normalizeWindowValues(values);
        let id = this.props.fields.id
        let operator = getAuthEmailFromToken();
        let obj = {
          id: id,
          farm: values['farm'],
          subject: values['subject'],
          start_time: start,
          end_time: end,
          desc: values['desc'],
          ci_status: values['ci_status'],
          operator: operator
        };
        if (this.props.type === 'Maintenance') {
          obj = {
            ...obj,
            upgrade_details: values['upgrade_details'],
            change_id: values['change_id'],
            label: values['label'],
            assigned_to: values['assigned_to'] || this.props.fields.assigned_to
          }
        }
        var fetchOption = {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
          },
          body: JSON.stringify(obj)
        }
        let url = `${OPS_DATA_URL}`
        if (this.props.type === 'Maintenance') {
          url = url + '/maintenances'
        } else {
          url = url + '/incidents'
        }
        try {
          const res = await fetch(url, fetchOption);
          if (res.ok) {
            this.loadingChangeState(false)
            this.props.onSubmit(true)
            return;
          }
          const errMsg = await this.parseErrorMessage(res);
          message.error(errMsg);
          this.loadingChangeState(false)
          this.props.onSubmit(false)
        } catch (error) {
          message.error('Network error while saving. Please try again.');
          this.loadingChangeState(false)
          this.props.onSubmit(false)
        }
      }
    })

  }

  submitClick = async (e) => {
    let authToken = authenticateToken();
    const { form } = this.formRef.props;
    e.preventDefault()

    form.validateFields(async (err, values) => {
      if (!!err) {
        return;
      } else {
        this.loadingChangeState(true)
        const { start, end } = this.normalizeWindowValues(values);
        let operator = getAuthEmailFromToken();
        let obj = {
          farm: values['farm'],
          subject: values['subject'],
          start_time: start,
          end_time: end,
          desc: values['desc'],
          ci_status: values['ci_status'],
          operator: operator
        };
        if (this.props.type === 'Maintenance') {
          obj = {
            ...obj,
            upgrade_details: values['upgrade_details'],
            change_id: values['change_id'],
            label: values['label'],
            assigned_to: values['assigned_to']
          }
        }
        var fetchOption = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
          },
          body: JSON.stringify(obj)
        }
        let url = `${OPS_DATA_URL}`
        if (this.props.type === 'Maintenance') {
          url = url + '/maintenances'
        } else {
          url = url + '/incidents'
        }
        try {
          const res = await fetch(url, fetchOption);
          if (res.ok) {
            const result = await res.json();
            this.setState({
              data: result,
              loading: false
            })
            this.loadingChangeState(false)
            this.props.onSubmit(true)
            return;
          }
          const errMsg = await this.parseErrorMessage(res);
          message.error(errMsg);
          this.loadingChangeState(false)
          this.props.onSubmit(false)
        } catch (error) {
          message.error('Network error while saving. Please try again.');
          this.loadingChangeState(false)
          this.props.onSubmit(false)
        }
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isEdit) {
      this.setState({
        fields: nextProps.fields
      })
    } else {
      const startTime = getNowTimestamp();
      this.setState({
        fields: {
          'start_time': startTime,
          'end_time': startTime + (60 * 60 * 1000),
          'subject': '',
          'desc': '',
          'upgrade_details': '',
          'change_id': '',
          'label': '',
          'assigned_to': ''
        }
      })
    }
  }

  onCancel = (e) => {
    e.preventDefault()
    this.formRef.props.form.resetFields()
    this.setState({
      fields: {}
    })
    this.props.onCancel()
  }

  saveFormRef = formRef => {
    this.formRef = formRef
  }

  render() {
    const { fields } = this.state;
    const { title, visible } = this.props;

    return (
      <Modal
        visible={visible}
        onCancel={this.onCancel}
        id="deploy-tenant-modal-container"
        title={title}
        width='60%'
        destroyOnClose
        footer={[
          <Button key="back" onClick={this.onCancel}>
            Cancel
            </Button>,
          <Button key="submit" type="primary" loading={this.state.loading} onClick={this.props.isEdit ? this.submitEditClick : this.submitClick}>
            Submit
            </Button>,
        ]}
      >
        <CustomizedForm  {...fields} type={this.props.type} onChange={this.handleFormChange} wrappedComponentRef={this.saveFormRef} isEdit={this.props.isEdit} />
      </Modal>
    );
  };
}

export default MaintenceDataModalPage
